import { MaterialCommunityIcons } from "@expo/vector-icons";
import { HStack, Icon, Pressable, Text, VStack } from "native-base";
import { InterfaceVStackProps } from "native-base/lib/typescript/components/primitives/Stack/VStack";
import React from "react";

import { useAppNavigation } from "@/hooks/application/navigation";
import { useAddress } from "@/hooks/domain/address";
import { Address } from "@/interfaces/domain/Address";
import { RootNavigation } from "@/navigation/Root";

type HeaderAddressButtonProps = {
  showCompletion?: boolean;
  defaultAddress?: Address;
} & InterfaceVStackProps;

const HeaderAddressButton = ({
  showCompletion = false,
  defaultAddress = null,
  ...props
}: HeaderAddressButtonProps) => {
  const { navigate } = useAppNavigation<RootNavigation>();
  const { addressList, principalAddress } = useAddress();
  const listIsEmpty = !addressList.length;
  const address = defaultAddress ?? principalAddress;
  const hasAddress = !!address;
  return (
    <VStack
      w={{
        base: "200px",
        lg: "240px",
      }}
      {...props}>
      <Text fontWeight="medium">Entregar em:</Text>
      <Pressable
        overflow="hidden"
        variant="ghost"
        colorScheme="primary"
        p="1"
        justifyContent="flex-start"
        onPress={() =>
          navigate("addressStack", { screen: !listIsEmpty ? "addressList" : "newAddress" })
        }>
        <HStack>
          <Icon as={<MaterialCommunityIcons name="map-marker" />} size="md" color="primary.600" />
          <VStack maxW="90%">
            <Text isTruncated bold color="primary.600">
              {hasAddress ? `${address.rua}, ${address.numero}` : "Adicionar endereço"}
            </Text>
            {showCompletion && hasAddress && (
              <Text isTruncated color="text.400">
                {address.complemento}
              </Text>
            )}
          </VStack>
        </HStack>
      </Pressable>
    </VStack>
  );
};

export default HeaderAddressButton;
